import gql from 'graphql-tag';

import { Query, Mutation } from 'core/index';

import { CONTENT_FIELDS } from 'apps/content/gql';
import { USER_ERROR_FIELDS } from 'core/errors';

export const COMMENT_CONNECTION_FIELDS = gql`
  ${CONTENT_FIELDS}
  fragment commentConnectionFields on CommentConnection {
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      cursor
      node {
        id
        canUpdate
        canDelete
        body
        content {
          ...contentFields
        }
        inSpace {
          id
        }
        creatorProfile {
          id
          username
          preferredName
          imageFallbackChar
          avatar {
            id
            path
            url
          }
          user {
            id
            username
          }
        }
        dateCreated
        lastUpdated
      }
    }
  }
`;

export const COMMENT_MUTATION = gql`
  ${CONTENT_FIELDS}
  ${USER_ERROR_FIELDS}
  mutation Comment($commentInput: CommentInput) {
    comment(commentData: $commentInput) {
      comment {
        id
        canUpdate
        canDelete
        body
        content {
          ...contentFields
        }
        inSpace {
          id
        }
        creatorProfile {
          id
          username
          preferredName
          avatar {
            id
            path
            url
          }
          user {
            id
            username
          }
        }
        dateCreated
        lastUpdated
      }
      userErrors {
        ...userErrorFields
      }
    }
  }
`;

export class CommentMutation extends Mutation {
  static conf = {
    GQL: COMMENT_MUTATION,
    inputName: 'commentInput',
    resultPath: 'comment.comment',
    errorPath: 'comment.userErrors',
  };
}

export const COMMENTS_CONNECTION = gql`
  ${COMMENT_CONNECTION_FIELDS}
  query StoryComments(
    $origin: ID
    $cursor: String
    $batchSize: Int
    $sortBy: String
  ) {
    comments(
      origin: $origin
      first: $batchSize
      after: $cursor
      sortBy: $sortBy
    ) {
      ...commentConnectionFields
    }
  }
`;

export class CommentsQuery extends Query {
  static conf = {
    GQL: COMMENTS_CONNECTION,
    varNames: ['origin', 'sortBy', 'cursor', 'batchSize'],
    resultPath: 'comments',
  };
}
